import React, { useContext, useEffect, useRef, useState } from 'react'
import { StyledBanner } from './EmailBanner.styled'
import { TNLink } from './TNLink'
import { tokens } from '@news-mono/design-tokens'
import { useSendVerifyEmail } from '../hooks/useSendVerifyEmail'
import { MyAccountContext } from '../hooks/useMyAccountContext'
import { useSelector } from 'react-redux'
import { AppState } from '@news-mono/web-common'

const { starlight } = tokens.thenightly.colors.palette

export const EmailBanner = () => {
    const { wanUserId: auth0UserId, emailVerified } = useSelector(
        (state: AppState) => state.authentication,
    )
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const ctx = useContext(MyAccountContext)
    const { mutateAsync: sendEmail } = useSendVerifyEmail(auth0UserId)

    const showBanner = !emailVerified && ctx.screen !== 'verify-email'
    async function sendVerifyEmail() {
        if (isLoading) return
        setIsLoading(true)
        const response = await sendEmail()
        if (response) {
            ctx.setScreenSelected(true)
            ctx.setScreen('verify-email')
        } else {
            ctx.setMessageBanner({
                text: 'Failed to send email, please try again later.',
                type: 'error',
            })
        }
        setIsLoading(false)
    }
    return showBanner ? (
        <StyledBanner>
            <p>
                Verify your account to unlock full access. &nbsp;
                <TNLink
                    color={starlight.default}
                    onClick={sendVerifyEmail}
                    fontWeight={400}
                    display="block"
                >
                    Resend verification email
                </TNLink>
            </p>
        </StyledBanner>
    ) : null
}
